import { apiFetchBlob } from './supabaseClient';

export function safeHoursFilename(value) {
  const name = String(value || 'RestaurantOS_Ore.pdf').normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9_.-]/g, '_').slice(0, 140);
  return `${name.replace(/\.pdf$/i, '') || 'RestaurantOS_Ore'}.pdf`;
}

function nativeDocuments() {
  const cap = window.Capacitor;
  if (cap?.isNativePlatform?.() !== true) return null;
  if (cap.getPlatform?.() !== 'ios') throw new Error('Condivisione PDF nativa non disponibile su questo dispositivo');
  const plugin = cap.Plugins?.RestaurantOSDocuments
    || (typeof cap.registerPlugin === 'function' ? cap.registerPlugin('RestaurantOSDocuments') : null);
  if (!plugin?.sharePdf) throw new Error('Il download PDF richiede la versione iOS aggiornata dell’app');
  return plugin;
}

function base64Blob(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1]);
    reader.onerror = () => reject(new Error('Impossibile preparare il PDF'));
    reader.readAsDataURL(blob);
  });
}

export async function downloadHoursPdf(path, filename) {
  const plugin = nativeDocuments();
  const iosBrowser = !plugin && /iPad|iPhone|iPod/.test(navigator.userAgent);
  // Same activation-preserving pattern used by Turni for Safari downloads.
  const reserved = iosBrowser ? window.open('', '_blank') : null;
  if (reserved) reserved.opener = null;
  let url;
  try {
    const blob = await apiFetchBlob(path);
    if (!blob?.size || blob.type?.split(';')[0].toLowerCase() !== 'application/pdf' || blob.size > 20 * 1024 * 1024) {
      throw new Error('Il server non ha restituito un PDF valido o il file è troppo grande');
    }
    const safeName = safeHoursFilename(filename);
    if (plugin) {
      const result = await plugin.sharePdf({ filename: safeName, base64: await base64Blob(blob) });
      if (typeof result?.cancelled !== 'boolean') throw new Error('Condivisione PDF non confermata');
      return { cancelled: result.cancelled };
    }
    url = URL.createObjectURL(blob);
    if (reserved && !reserved.closed) {
      reserved.location.href = url;
    } else {
      const a = document.createElement('a');
      a.href = url; a.download = safeName;
      if (iosBrowser) { a.target = '_blank'; a.rel = 'noopener'; }
      document.body.appendChild(a); a.click(); a.remove();
    }
    return { cancelled: false };
  } catch (error) {
    if (reserved && !reserved.closed) reserved.close();
    if (error?.name === 'AbortError') return { cancelled: true };
    throw error;
  } finally {
    if (url) setTimeout(() => URL.revokeObjectURL(url), 60_000);
  }
}
